<template>
  <PrintPageLandscape
    :page-number="pageNumber"
    :page-count="pageCount"
    :background-image-url="'/img/short_teaser/short_teaser_bg.png'"
  >
    <div class="short-teaser-inner-page" :data-project-number="project ? project.number : null">
      <h2 class="short-teaser-inner-page__heading">{{ $t('shortTeaserPrintPage5_heading') }}</h2>
      <div class="short-teaser-inner-page__main">
        <figure class="short-teaser-inner-page__figure">
          <img
            class="short-teaser-inner-page__photo"
            src="/img/short_teaser/short_teaser_eeg_2026.jpg"
            :alt="$t('shortTeaserPrintPage5_eegImageAlt')"
          />
        </figure>
      </div>
    </div>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';

export default {
  name: 'ShortTeaserPrintPage5',

  components: {
    PrintPageLandscape,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },
};
</script>
